import React from "react";
import { Box, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

export default function ViewKPIIconDesign({
  size = 30,
  color = "#4F46E5",
  onClick,
}) {
  return (
    <Tooltip title="View" arrow>
      <Box
        sx={{
          width: size,
          height: size,
          backgroundColor: color,
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: onClick ? "pointer" : "default",
          "&:hover": {
            backgroundColor: "#fff",
            border: `2px solid ${color}`,
            "& .icon": {
              color: color,
            },
          },
        }}
        onClick={onClick}
      >
        <VisibilityIcon
          className="icon"
          sx={{ color: "#fff", fontSize: size * 0.6 }}
        />
      </Box>
    </Tooltip>
  );
}
